
import { EmailWithType } from '@/types/lead';

/**
 * Formats an email value for display, handling different types:
 * - string: returns the string directly
 * - EmailWithType: returns the email property
 * - EmailWithType[]: returns a comma-separated list of email addresses
 */
export const formatEmailForDisplay = (email: string | EmailWithType | EmailWithType[] | null | undefined): string => {
  if (!email) return '';
  
  if (typeof email === 'string') {
    return email;
  }
  
  if (Array.isArray(email)) {
    return email.map(e => e.email).join(', ');
  }
  
  // Single EmailWithType object
  return email.email;
};

/**
 * Returns the primary or first email address from any email format
 */
export const getPrimaryEmail = (email: string | EmailWithType | EmailWithType[] | null | undefined): string => {
  if (!email) return '';
  
  if (typeof email === 'string') {
    return email;
  }
  
  if (Array.isArray(email)) {
    // Try to find a primary email (e.g. info@, contact@)
    const primaryTypes = ['primary', 'main', 'info', 'contact', 'general'];
    
    // First look for emails with primary types
    for (const type of primaryTypes) {
      const primaryEmail = email.find(e => 
        e.type && e.type.toLowerCase().includes(type)
      );
      if (primaryEmail) return primaryEmail.email;
    }
    
    // If no primary type is found, return the first email
    return email.length > 0 ? email[0].email : '';
  }
  
  // Single EmailWithType object
  return email.email;
};
